<template>
  <div class="container-fluid">
    <!-- 카카오 인증 완료 -->
    <article v-if="isVerified">
      <dl class="text-start">
        <dt class="fs-3">본인 인증이<br/>완료되었습니다 :)</dt>
        <dd>아래 정보를 확인해주세요.</dd>
      </dl>
      <div class="card">
        <div class="card-body text-start">
          <div class="row gap-1">
            <div class="row">
              <label for="inputEmail3" class="col-4 col-form-label">이름</label>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputEmail3" :value="userInfo.name" readonly>
              </div>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputEmail4" :value="nationalName" readonly>
              </div>
            </div>
            <div class="row">
              <label for="inputPassword3" class="col-4 col-form-label">생년월일</label>
              <div class="col-4 px-0">
                <input type="text" class="form-control" id="inputPassword3" :value="userInfo.birth" readonly>
              </div>
              <div class="col-4 px-0">
                <div class="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                  <button class="btn gender-button" :class="userGender === '1' ? 'active' : 'non-active'">남</button>
                  <button class="btn gender-button" :class="userGender === '0' ? 'active' : 'non-active'">여</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer mt-3 d-flex gap-1 justify-content-end">
        <button class="btn btn-primary col-12 rounded-pill" @click="moveAfter">다음</button>
      </footer>
    </article>
  </div>
</template>

<script>
import Utils from "@/assets/js/CommonComposables";
import parsePhoneNumberFromString from "libphonenumber-js/max";

// import * as Utils from "@/assets/js/CommonComposables";
// import parsePhoneNumberFromString from "libphonenumber-js/max";

/**
 * 간편회원가입 - 본인인증 페이지
 */
// NationalNumber 객체 정의
export default {
  name: "SocialLoginValidation",
  data(){
    return {
      currentPageData: {
        page : '',
      },
      userInfo : {
        birth : '850812',
        gender : '1',
        name : '홍길동',
        national : '1',
        mobile : '01012341234',
      },
      selectedGender : 0,
      nationalName : '',
      isVerified:true,
      homeName:'',
      joinUrl:'',
      test_mode:false,
      code:'',
    }
  },
  computed: {
    userGender() {
      return this.selectedGender;
    },
  },
  async mounted() {
    this.joinUrl = this.$store.getters.getJoinUrl; // 다음 페이지 이동시 필요
    this.test_mode = this.$store.getters.getTestEnv; // 테스트 모드시 필요
    this.homeName = this.joinUrl === 'mancharo' ? '만차로' : '화물맨';

    if (this.$store.getters.getTestEnv) {
      // 테스트로 접속한 경우
    } else {
      this.userInfo.birth = '';
      this.userInfo.gender = '';
      this.userInfo.name = '';
      this.userInfo.national = '';
      this.userInfo.mobile = '';
    }

    // 정보얻기
    await this.$http.post('/api/kakao/member/info',
        {access_token: this.$store.getters.getAccessToken})
        .then(async res=> {
          const response = res.data;

          if (response.error) {
            // 이미 카카오 계정이 있는 경우
            this.isVerified = false; //창 숨기기
            await this.$swal.fire({title:response.message});
            await this.$router.push({ path: '/' });
            return;
          }

          const kakaoAccount = response.data.kakao_account;
          const kakaoId = response.data.id;

          if (Utils.isNotNull(kakaoAccount)) {
            //이름,전화번호,생일,출생년도,성별 확인하기
            const phoneNumber = parsePhoneNumberFromString(kakaoAccount.phone_number);
            if(Utils.isNotNullAll(kakaoAccount.name,kakaoAccount.birthyear,kakaoAccount.birthday,kakaoAccount.phone_number,kakaoAccount.gender)){
              // 데이터가 모두 있는 경우 기존과 동일하게 데이터를 넣습니다. + 성별 추가해야합니다.
              // 소셜 로그인 확인
              this.$store.commit('changeIsSocialLogin',true);
              this.userInfo.name = kakaoAccount.name;
              this.userInfo.gender = '';
              const birth = `${kakaoAccount.birthyear}${kakaoAccount.birthday}`;
              this.userInfo.birth = birth.length === 8 ? birth.substring(2) : birth;
              this.userInfo.mobile = this.removeHyphens(phoneNumber.formatNational());
              this.selectedGender = kakaoAccount.gender === 'male' ? '1' : '0';
              this.$store.commit('setMemberInfo', this.userInfo);
              this.$store.commit('setSocialId',kakaoId);
            } else {
              // 데이터가 없는 경우 본인 인증 넘어가기
              this.kakaoUnlink();
              // 본인인증하기
              this.showConfirm();
            }
          } else {
            // 카카오 로그인을 하다가 취소나 기타 오류가 발생할 경우
            this.kakaoUnlink();
          }
        })
        .catch(ex=>{
          console.log("ex",ex);
        });

    // 정보얻기
    // await this.$http.post('/api/naver/member/info',
    //     {access_token: this.$store.getters.getAccessToken})
    //     .then(async res=> {
    //       const response = res.data;
    //       if (response.error) {
    //         // 이미 카카오 계정이 있는 경우
    //         this.isVerified = false; //창 숨기기
    //         await this.$swal.fire({title:response.message});
    //         await this.$router.push({ path: '/' });
    //         return;
    //       }
    //
    //       const naverAccount = response.data.response;
    //       console.log(naverAccount);
    //       if (Utils.isNotNull(naverAccount)) {
    //         //이름,전화번호,생일,출생년도,성별 확인하기
    //         if(Utils.isNotNullAll(naverAccount.name,naverAccount.birthyear,naverAccount.birthday,naverAccount.mobile,naverAccount.gender,naverAccount.id)){
    //           // 데이터가 모두 있는 경우 기존과 동일하게 데이터를 넣습니다. + 성별 추가해야합니다.
    //           // 소셜 로그인 확인
    //           this.$store.commit('changeIsSocialLogin',true);
    //           this.userInfo.name = naverAccount.name;
    //           this.userInfo.gender = '';
    //           this.userInfo.birth = `${naverAccount.birthyear}${this.removeHyphens(naverAccount.birthday)}`;
    //           this.userInfo.mobile = this.removeHyphens(naverAccount.mobile);
    //           this.selectedGender = naverAccount.gender === 'M' ? '1' : '0';
    //           this.$store.commit('setMemberInfo', this.userInfo);
    //           this.$store.commit('setSocialId',naverAccount.id);
    //         } else {
    //           console.log("오류 발생");
    //
    //           // 데이터가 없는 경우 본인 인증 넘어가기
    //           // this.kakaoUnlink();
    //           // 본인인증하기
    //           // this.showConfirm();
    //         }
    //       } else {
    //         // 카카오 로그인을 하다가 취소나 기타 오류가 발생할 경우
    //         console.log("오류 발생");
    //         // this.kakaoUnlink();
    //       }
    //     })
    //     .catch(ex=>{
    //       console.log("ex",ex);
    //     });
  },
  methods:{
    kakaoUnlink(){ //연동 해제
      const initialized = window.Kakao.isInitialized();
      if(initialized){
        window.Kakao.Auth.setAccessToken(this.$store.getters.getAccessToken);
        window.Kakao.API.request({
          url: '/v1/user/unlink',
        })
            .then(function(response) {
              console.log(response);
            })
            .catch(function(error) {
              console.log(error);
            });
      } else {
        //카카오 오류 발생
      }
    },
    async moveAfter(){

      //테스트 모드가 아닐 경우 실행
      const nextPageInfo = await this.$http.post('/api/user/reg/mmn/v2', this.userInfo)
          .catch(err=> {
            this.$swal.fire('에러 : '+err.message);
          });

      if (nextPageInfo === undefined) {
        return ;
      }

      // if(nextPageInfo.data.code !== 200){
      //   await this.$swal.fire(`회원님은 서비스 \n이용이력이 있으신 회원이십니다.\n콜센터를 통해서 \n가입신청을 진행하십시오.`);
      //   return;
      // }
      if(nextPageInfo.data.code !== 200){
        await this.$swal.fire(`${nextPageInfo.data.message}`);
        await this.$router.push({ path: '/' });
        return;
      }

      const response_data = nextPageInfo.data.data;
      const pageRouteInfo = response_data.router_view;
      const user_seq = response_data.user_seq;
      // 가입 경로부터 확인하기
      console.log(`sessionStorage.getItem("grade-code") => `, sessionStorage.getItem("grade-code"));
      console.log(`typeof sessionStorage.getItem("grade-code") => `,typeof sessionStorage.getItem("grade-code"));
      console.log(`compare sessionStorage.getItem("grade-code") => `,sessionStorage.getItem("grade-code") === '100208');
      /*
      라우터 위치 정하기
       8 - 화물맨
      11 - 만차로
      12 - 아틀란
      20 - 회원가입 간소화
       */
      if (pageRouteInfo === 'UNKNOWN_MEMBER') {
        console.log("신규가입 대상자입니다.")
        //화물맨 기본 로직
        const join_path = sessionStorage.getItem("grade-code");

        if (join_path === '8' || join_path === '11') {
          this.currentPageData.page = 'hmm';
        } else if (join_path === '12') {
          this.currentPageData.page = 'atl';
        } else if (join_path === '100208') {
          this.currentPageData.page = 'event20';
        } else {
          // 끝자리 2자리에서 0 제거
          let modifiedPath = join_path;
          if (modifiedPath.length >= 2) {
            const lastTwo = modifiedPath.slice(-2); // 끝 2자리 추출
            if (lastTwo.includes('0')) {
              modifiedPath = modifiedPath.replace(/0+$/, ''); // 끝에서 0 제거 (연속된 0도 처리)
            }
          }

          // 수정된 값으로 기존 조건 적용
          if (modifiedPath === '8' || modifiedPath === '11') {
            this.currentPageData.page = 'hmm';
          } else if (modifiedPath === '12') {
            this.currentPageData.page = 'atl';
          } else {
            this.currentPageData.page = 'hmm';
          }
        }
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$emit('current-page',this.currentPageData);
        return;
      }
      this.$store.commit('setUserSeq', user_seq);

      // if (pageRouteInfo === "INFO") {
      //   console.log("가입완료 했지만 회원정보가 다 없는 경우")
      //
      //   const join_path = sessionStorage.getItem("grade-code");
      //
      //   if (join_path === '8' || join_path === '11') {
      //     this.currentPageData.page = 'hmm';
      //   } else if (join_path === '12') {
      //     this.currentPageData.page = 'atl';
      //   } else if (join_path === '100208') {
      //     this.currentPageData.page = 'event20';
      //   }
      //   //
      //   this.$store.commit('setMemberInfo', this.userInfo);
      //   this.$emit('current-page',this.currentPageData);
      //   return;
      // }

      if (pageRouteInfo === "INFO") {
        // 가입 완료했지만 회원 정보가 다 입력 안되고 첨부서류는 납부된 경우
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      if (pageRouteInfo === "PAPER") {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-paper';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      if (pageRouteInfo.includes("PAPER") && pageRouteInfo.includes("INFO")) {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
      }
    },
    showConfirm(){
      if(this.test_mode){
        //테스트용 성별 값
        this.isVerified = true;
        this.selectedGender = '1';
        this.nationalName = '내국인';
        this.userInfo.mobile = this.generatedPhoneNumber();
        this.$store.commit('setMemberInfo',this.userInfo);
        return;
      }
      //본인인증
      window.addEventListener("message", this.receiveMessage, false);
      window.open('https://auth.bgsoft.kr:8443/nice_module/chk', '_blank',  'width=500,height=600' );
    },
    async receiveMessage(response){
      const name = response.data.name;
      const mobile = response.data.phone;
      const birth = response.data.birth;
      const national = response.data.national;
      const gender = response.data.gender;

      if(this.isEmpty(name) || this.isEmpty(mobile)){
        await this.$swal.fire('오류가 발생했습니다.');
        this.isVerified = false;
        return;
      }

      this.userInfo.name = name;
      this.userInfo.mobile = mobile;
      this.userInfo.birth = birth;
      this.userInfo.national = national;
      this.userInfo.gender = this.changeGenderCode(national,gender,birth);

      this.selectedGender = gender;
      this.nationalName = this.getNationality(national);

      this.isVerified = true;
      this.$store.commit('setMemberInfo',this.userInfo);

    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    changeGenderCode(national, gender, birth){
      if (national == "0") {  //내국인
        if (gender == "1") { //남성(1)
          if (birth[0] =="2"){  //2000년대생
            return "3";
          } else {
            return "1";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "4";
          } else {
            return "2";
          }
        }
      } else {  //외국인
        if (gender == "1") { //남성(1)
          if (birth[0] == "2"){  //2000년대생
            return "7";
          } else {
            return "5";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "8";
          } else {
            return "6";
          }
        }
      }
    },
    getNationality(national){
      return national == '0' ? '내국인' : '외국인';
    },
    generatedPhoneNumber(){
      let min = Math.pow(10, 10);
      let max = Math.pow(10, 11) - 1;
      // Math.random()을 사용하여 랜덤 숫자 생성 후 11자리로 만듭니다.
      let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

      return randomNumber.toString(); // 문자열로 반환
    },
    removeHyphens(str) {
      return str.replace(/-/g, '');
    },
  },
}
</script>

<style scoped>
/* 스타일 수정 */
.gender-button {
  color: #333;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
}

.gender-button.active {
  background-color: #4fb1ec;
  border-color: #4fb1ec;
  color: #fff;
  pointer-events: none;
}

.gender-button.non-active {
  background-color: #ccc; /* 회색 배경색으로 변경 */
  color: #fff; /* 회색 텍스트색으로 변경 */
  pointer-events: none;
}
img {
  max-width: 100%;
}
</style>